import * as Sentry from '@sentry/browser'
import * as O from 'fp-ts/lib/Option'

import { ApiError, ApiErrorHolder, DecodeError } from '../services/error'
import { tryParseErrorPayload } from './api-error-parser'

type OnError = (e: any) => any
type OnUnauthorizedError = () => any
const logger = '[ErrorHandler]'
export function handleError(
  onUnauthorizedError: OnUnauthorizedError,
  defaultOnError: OnError
) {
  return (e: Error, onError: OnError = defaultOnError) => {
    if (e instanceof ApiErrorHolder) {
      handleApiError(e.err, onUnauthorizedError, onError)
      return
    }

    if (e instanceof DecodeError) {
      handleDecodeError(e, onError)
      return
    }

    console.error(logger, 'Unexpected error', e)
    Sentry.captureException(e)
    onError(e)
  }
}

function handleApiError(
  e: ApiError,
  onUnauthorizedError: OnUnauthorizedError,
  onError: OnError
) {
  switch (e.name) {
    case 'UnauthorizedError':
      onUnauthorizedError()
      return
    case 'GeneralApiError':
      const maybeErrorPayload = tryParseErrorPayload(e)
      if (O.isSome(maybeErrorPayload)) {
        console.log(
          logger,
          'Unexpected API error with payload',
          maybeErrorPayload.value
        )
        const payload = maybeErrorPayload.value
        Sentry.captureEvent({
          exception: {
            values: [{ type: payload.errorCode, value: payload.message }]
          },
          extra: { payload }
        })
      } else {
        console.error(logger, 'Unexpected API error', e)
        Sentry.captureException(e)
      }
      onError(e)
      return
    default:
      const _: never = e
      return _
  }
}

function handleDecodeError(e: DecodeError, onError: OnError) {
  console.error(logger, e.name, e, e.errors)
  Sentry.captureEvent({
    exception: { values: [{ type: e.name, value: e.message }] },
    extra: { errors: e.errors }
  })
  onError(e)
}
